import { Component } from '@verndale/core';
import _debounce from 'lodash.debounce';
import { isTabletLandscape } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $formContainer: this.el._$('.campaign-landing-form__form-container'),
      $contentWrapper: this.el._$('.campaign-landing-form__content'),
      $bgContainer: this.el._$('.campaign-landing-form__content-bg'),
      $imageContainer: this.el._$('.campaign-landing-form__image-container'),
      $img: this.el._$('.campaign-landing-form__image-container img')
    }

    this.setModuleHeight();
  }

  addListeners() {
    window._on('resize', _debounce(this.setModuleHeight.bind(this), 200));
    if (this.dom.$img && !this.dom.$img.complete) this.dom.$img._on('load', this.setModuleHeight.bind(this));
    const observer = new MutationObserver(this.formMutationObserver.bind(this));
    observer.observe(this.dom.$formContainer, {
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });
  }

  formMutationObserver(mutations) {
    mutations.forEach(mutation => {
      // Check if the mutation could affect input visibility
      if (mutation.type === 'attributes') {
        const target = mutation.target;
        // Check if it's an input or form element that could be showing/hiding
        if (target.tagName === 'INPUT' || target.tagName === 'DIV' || target.tagName === 'FIELDSET') {
          // Trigger height recalculation after a short delay to let DOM update
          if (this.heightRecalculationTimeout) {
            clearTimeout(this.heightRecalculationTimeout);
          }
          this.heightRecalculationTimeout = setTimeout(() => {
            this.setModuleHeight();
          }, 100);
        }
      }
    })
  }

  setModuleHeight() {
    const formContainerHeight = this.getElementProperty(this.dom.$formContainer, 'height');
    const formContainerTop = this.getElementProperty(this.dom.$formContainer, 'top');
    const formContainerMarginTop = this.getElementProperty(this.dom.$formContainer, 'margin-top');
    const contentWrapperHeight = this.getElementProperty(this.dom.$contentWrapper, 'height');

    if (!this.wrapperHeight) this.wrapperHeight = contentWrapperHeight;

    if (isTabletLandscape()) {
      this.el.style.height = `${formContainerHeight + formContainerMarginTop + contentWrapperHeight + 60}px`;
    } else {
      let finalHeight = 0;

      if (formContainerHeight < contentWrapperHeight) {
        finalHeight = formContainerTop + contentWrapperHeight;
      } else {
        finalHeight = formContainerTop + formContainerHeight;
      }

      this.el.style.height = `${finalHeight}px`;

      if (!this.dom.$imageContainer){
        if (finalHeight - 295 < contentWrapperHeight) {
          this.dom.$bgContainer.style.minHeight= `${contentWrapperHeight+30}px`;
        }
      }
    }
  }

  getElementProperty(el, prop) {
    return Math.round(window.getComputedStyle(el).getPropertyValue(prop).split('px')[0]);
  }
}

export default Module;
